import { FC } from 'react';
import { Typography } from '@mui/material';

type DateFieldLabelProps = {
  label: string;
};

export const DateFieldLabel: FC<DateFieldLabelProps> = ({ label }) => {
  const labelTextStyle = {
    color: 'rgba(27, 61, 85, 0.6)',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  };

  return (
    <Typography variant="body2" sx={labelTextStyle}>
      {label}
    </Typography>
  );
};
